import { render } from "./AgentLandingBlockBetterWay.vue?vue&type=template&id=01cc3218&scoped=true&lang=pug"
import script from "./AgentLandingBlockBetterWay.vue?vue&type=script&lang=js"
export * from "./AgentLandingBlockBetterWay.vue?vue&type=script&lang=js"

import "./AgentLandingBlockBetterWay.vue?vue&type=style&index=0&id=01cc3218&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cc3218"]])

export default __exports__